import { render, staticRenderFns } from "./GreenOperationHistoricalHistory.vue?vue&type=template&id=39bfdad4&scoped=true&"
import script from "./GreenOperationHistoricalHistory.vue?vue&type=script&lang=js&"
export * from "./GreenOperationHistoricalHistory.vue?vue&type=script&lang=js&"
import style0 from "./GreenOperationHistoricalHistory.vue?vue&type=style&index=0&id=39bfdad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bfdad4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39bfdad4')) {
      api.createRecord('39bfdad4', component.options)
    } else {
      api.reload('39bfdad4', component.options)
    }
    module.hot.accept("./GreenOperationHistoricalHistory.vue?vue&type=template&id=39bfdad4&scoped=true&", function () {
      api.rerender('39bfdad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/GreenOperationHistoricalHistory.vue"
export default component.exports